function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#dde0e5}.cls-3{fill:#aeb8c2}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1174",
  transform: "translate(-813 -462)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_456",
  fill: "#f5f5f7",
  d: "M17809.287 19213.055h-48.668v-8.217a8.314 8.314 0 0 0-8.387-8.221H17743v9.883-78.92a6.653 6.653 0 0 1 6.715-6.574h70.48a6.653 6.653 0 0 1 6.715 6.574v69.041h-9.23a8.424 8.424 0 0 0-5.932 2.408 8.07 8.07 0 0 0-2.459 5.813v8.217z",
  transform: "translate(-16911.541 -18659.002)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_453",
  d: "M17854.6 19257.383h-103.209a8.314 8.314 0 0 1-8.391-8.217V19213h18.457v9.885-9.885h9.234a8.319 8.319 0 0 1 8.389 8.225v8.215h48.66v-8.215a8.058 8.058 0 0 1 2.461-5.812 8.407 8.407 0 0 1 5.93-2.412h26.854v36.168a8.315 8.315 0 0 1-8.385 8.214z",
  className: "cls-2",
  transform: "translate(-16930 -18675.385)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_455",
  d: "M-16983.187-18593.408l.008 21.7-18.436-.008z",
  className: "cls-3",
  transform: "translate(17814.639 19109.324)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_460",
  d: "M-17001.918-18593.461l-.01 21.7h17.572z",
  className: "cls-3",
  transform: "translate(17917.355 19109.346)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_457",
  d: "M5.034 0h51.184a4.984 4.984 0 0 1 5.034 4.932v22.191a4.984 4.984 0 0 1-5.034 4.932H5.034A4.984 4.984 0 0 1 0 27.123V4.932A4.984 4.984 0 0 1 5.034 0z",
  className: "cls-2",
  transform: "translate(842.368 472.685)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_458",
  d: "M2.517 0h56.218a2.492 2.492 0 0 1 2.517 2.466 2.492 2.492 0 0 1-2.517 2.466H2.517A2.492 2.492 0 0 1 0 2.466 2.492 2.492 0 0 1 2.517 0z",
  className: "cls-2",
  transform: "translate(842.368 516.247)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_459",
  d: "M2.517 0h56.218a2.492 2.492 0 0 1 2.517 2.466 2.492 2.492 0 0 1-2.517 2.466H2.517A2.492 2.492 0 0 1 0 2.466 2.492 2.492 0 0 1 2.517 0z",
  className: "cls-2",
  transform: "translate(842.368 529.397)"
}));

function SvgNoRecord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 119.998,
    viewBox: "0 0 120 119.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecord);
export default __webpack_public_path__ + "static/media/NoRecord.fbe91ea0.svg";
export { ForwardRef as ReactComponent };